import gql from 'graphql-tag'

export const GET_COMPANY = gql`
query(
    $UserId:ID
  ){
    getSCompany(UserId:$UserId){
      empId
      Logo
      companyName
      point
      owner
      manager
    }
  }
`
export const GET_USER = gql`
query(
  $UserId:ID 
){
  selectStaff(UserId:$UserId){
    UserId
    name
    email
    role
  }
}
`
export const SELECT_EMP = gql`

query(
  $UserId:ID
){
  selectEmp(UserId:$UserId){
    empId
    companyName
    isFeature
  }
}

`
export const ADD_FEATURE = gql`
mutation( 
  $empId:ID!
  $Profile:String,
  $Gallerys:[String], 
  $Peoples:[peopleInput],
  $Benefits:[benefits]
  $companyColor:String
  $isLink:String
){
  addFeature(info:{
    empId:$empId
    Profile:$Profile 
    Gallerys: $Gallerys
    Peoples:$Peoples
    Benefits:$Benefits
    companyColor:$companyColor
    isLink:$isLink
  })
}

`

export const ADD_SubEmployer = gql`

mutation (
  $UserId:[ID]
  $logo: String
	$companyName: String!
	$aboutCompany: String!
	$industryId: [ID]!
	$companySizeId: ID
	$website: String!
	$facebook: String!
	$nortificationEmails: [String]
	$appliedEmails: [String]
	$notifyExpire: [String]
	$village: String
	$districtId: ID!
	$country: String!
	$phone: String
	$Profile: String
  $featureProfile:String
  $isFeature: Boolean
	$Gallerys: [String]
	$Peoples: [peopleInput]
	$Benefits: [benefits]
	$companyColor: String
  $textColor:String
	$isLink: String
	$youtube: String
	$titok:String
	$twitter:String
	$linkIn:String
	$pService: [pServiceInput]
	$lng: Any
	$lat: Any
  $videoLink:String
  $cardCover:String
 ) {
   addCompany(info: {
      UserId:$UserId
      logo: $logo
			companyName: $companyName
			aboutCompany: $aboutCompany
			industryId: $industryId
			companySizeId: $companySizeId
			website: $website
			facebook: $facebook
			nortificationEmails: $nortificationEmails
			appliedEmails: $appliedEmails
			notifyExpire: $notifyExpire
			village: $village
			districtId: $districtId
			country: $country
			phone: $phone
			Profile: $Profile
			Gallerys: $Gallerys
			Peoples: $Peoples
			Benefits: $Benefits
      featureProfile:$featureProfile
			companyColor: $companyColor
      textColor: $textColor
      isFeature:$isFeature
			isLink: $isLink
			youtube: $youtube
			titok:$titok
			twitter:$twitter
			linkIn:$linkIn
			pService: $pService
			lng: $lng
			lat: $lat
      videoLink:$videoLink
      cardCover:$cardCover
   }
   )
   {
     userId
     name
     email
     empId
     companyName
     }
 }
    
    `
export const GET_COMPANY_ALL = gql`
    
    query(
      $id: ID!,
    )
    {
      findEmployer(id:$id ) {
        _id
        logo 
        companyName
        aboutCompany
        featureProfile
        industryId {
          _id
          name
        }
        companySizeId {
          _id
          name
        }
        website
        facebook
        nortificationEmails
        appliedEmails
        notifyExpire
        village
        districtId {
          _id
          name
          provinceId {
            _id
          }
        }
        country
        phone
        createdAt
        status
        isFeature
        Profile
        featureProfile
        companyColor
        textColor
        Gallerys
        Peoples{
          image
          video
          name
          position
          duty
        }
        Benefits{
          image
          details
        }
        isBann
        isLink
        UserId{
          _id
          fName
        }
        pService{
			title
			detail
      }
      titok
      youtube
      twitter
      linkIn
      map{type coordinates}
      videoLink
      cardCover
      }
     
    }
    
    `
export const GET_ACTIVITY = gql`
query(
  $UserId: String!
  $page:Int 
  $perPage:Int
){
  get_Activity(UserId:$UserId page:$page perPage:$perPage){
      info{
          _id
          activity
          creator 
        point
          employerId
          companyName
          description
          activityDate
          remark
      }
      total
  }
}
`